'use client';

import Image from 'next/image';

import { EmptyState } from '@/components/ui/empty-state/empty-state';

export const SearchEmpty = () => {
  return (
    <EmptyState
      icon={
        <Image
          alt="empty"
          src="/empty/empty-search.svg"
          width={300}
          height={300}
        />
      }
      title="Поиск не дал результатов"
      description="Попробуйте изменить параметры поиска"
    />
  );
};
